import Crud from './crud'
import { request_list } from '@/commons/hpod';
var crud = new Crud('products', 'sản phẩm');

const state = {
    ...crud.state,
    new: {},
    sale: {},
    exp: {},
    suggestions: {},
    selected: {
        id: 0
    }
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
    getListSale({ commit }, param = {}) {
        commit("setLoading", { loading: true });
        request_list('products', data => {
            commit('setListSale', data);
            commit("setLoading", { loading: false });
        }, param, this.state.authentication.token);
    },
    getListSuggestion({ commit }, param = {}) {
        request_list('products', data => {
            commit('setListSuggestion', data);
        }, param, this.state.authentication.token);
    },
    getExpList({ commit }, param) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                commit("setLoading", { loading: true });
                request_list('products/exp', item => {
                    commit('setExpList', item);
                    commit("setLoading", { loading: false });
                    resolve(item.data ? item.data : item);
                }, param, this.state.authentication.token);
            }, 100)
        })
    },
};
const mutations = {
    ...crud.mutations,
    setExpList(state, data) {
        state.exp = data;
    },
    setListSale(state, data) {
        state.sale = data;
    },
    setListSuggestion(state, data) {
        state.suggestions = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};